import {
    actionsLead as actions
} from "../actions/types";

const leadReducer = (state = null, action: any) => {
    switch (action.type) {
        case actions.SET_ID_LEAD:
            return action.payload;
        case actions.REMOVE_ID_LEAD:
            return null;
        default:
            return state;
    }
}

export default leadReducer;